export const GET_ALL_EVENT_SEARCH_AGENTS = 'action/search-agent/event/get/all'
export const SAVE_EVENT_SEARCH_AGENT = 'action/search-agent/event/save'
export const DELETE_EVENT_SEARCH_AGENT = 'action/search-agent/event/delete'
export const GET_ALL_JOB_SEARCH_AGENTS = 'action/search-agent/job/get/all'
export const SAVE_JOB_SEARCH_AGENT = 'action/search-agent/job/save'
export const DELETE_JOB_SEARCH_AGENT = 'action/search-agent/job/delete'
export const GET_SEARCH_AGENT = 'action/search-agent/get'
